module.exports = __webpack_public_path__ + "media/home/Press-2-6ef968cd.png";